import { GetServerSideProps } from "next";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect } from "react";

interface RedirectPageProps {
  ref_op: string;
  redirect: string;
}

function RedirectPage(props: RedirectPageProps) {
  const router = useRouter();

  useEffect(() => {
    localStorage.setItem("redirect", props.ref_op);
    if (props.redirect == "") {
      router.push("/");
    } else {
      router.push("/" + props.redirect);
    }
  }, []);

  const handleClick = (e: any) => {
    e.preventDefault();
    router.push("/");
  };

  return (
    <Link href="/">
      <a onClick={handleClick}></a>
    </Link>
  );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { query } = context;
  const ops = query.ops as string[];
  const ref = ops[0] ?? "";
  const redirect = ops.slice(1, ops.length).join("/") ?? "";
  console.log(query);
  console.log(ref);
  console.log(redirect);

  return {
    props: { ref_op: ref, redirect: redirect },
  };
};

export default RedirectPage;
